






























import CompanySheet from "@/components/company/CompanySheet.vue";
import DropAreaMulti from "@/components/files/DropAreaMulti.vue";
import LineItemsForm from "@/components/repair-estimate/LineItemsForm.vue";
import RepairEstimateForm from "@/components/repair-estimate/RepairEstimateForm.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { Reference } from "@/models/reference.entity";
import { IRepairEstimate, RepairEstimate } from "@/models/repair-estimate.entity";
import { SignDocument } from "@/models/sign-document.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({
  components: { CompanySheet, MNoContent, LineItemsForm, DropAreaMulti, RepairEstimateForm, ConfirmActionDialog },
  filters: {}
})
export default class PartnerReportRepairEstimateUpdateDialog extends mixins(PermissionMixin, RulesMixin)
  implements IDialog {
  @Prop({ default: false }) value!: boolean;
  @Prop() repairEstimate!: IRepairEstimate;

  dialog: boolean = this.value;
  localEstimate?: IRepairEstimate | null = null;
  requestsLoading = false;
  file: File | null = null;
  isValid = false;

  get files(): File[] {
    if (this.file) {
      return [this.file];
    }
    return [];
  }

  set files(files: File[]) {
    if (files.length > 0) {
      this.file = files[0];
    } else {
      this.file = null;
    }
  }

  get partner() {
    return PartnerModule.partner;
  }

  get context() {
    return {
      repairEstimate: this.localEstimate,
      partner: this.partner
    };
  }

  get validForm() {
    return this.isValid;
  }

  get myUserId() {
    return UserModule.userId;
  }

  @Watch("value")
  onValueChange(val: boolean) {
    if (val) {
      this.reset();
    }
    this.localEstimate = new RepairEstimate(this.repairEstimate);
    this.dialog = val;
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    this.$emit("input", val);
  }

  @Watch("file")
  setEstimateNumber() {
    if (!this.localEstimate) return;

    if (!this.localEstimate.number && this.file) {
      if (this.file.name?.endsWith(".pdf")) {
        this.localEstimate.number = this.file.name.substring(0, this.file.name.length - 4);

        return;
      }
      this.localEstimate.number = this.file.name;

      return;
    }
  }

  open() {
    this.dialog = true;
  }

  close() {
    this.dialog = false;
  }

  reset() {
    this.file = null;
    this.localEstimate = null;
  }

  async update() {
    if (!this.localEstimate) return;
    this.requestsLoading = true;

    try {
      const refs = [];

      const repairEstimate = await this.localEstimate.update();

      if (this.repairEstimate.reportId) {
        refs.push(new Reference({ refId: this.repairEstimate.reportId, refType: ResourceEnum.REPORT }));
      }

      refs.push(new Reference({ refId: repairEstimate.id, refType: ResourceEnum.APPRAISAL }));

      if (this.file) {
        const signDocument = new SignDocument({
          name: this.file.name,
          title: this.file.name,
          isTemplate: false,
          folder: "/repair-estimate/",
          refs: refs,
          file: this.file,
          partnerId: this.partner.id
        });

        await signDocument.create();

        await this.localEstimate.updatePartial({
          documentId: signDocument.id,
          status: RequestStatusEnum.REPLIED
        });
        this.localEstimate.document = signDocument;
      }

      this.$emit("update:repairEstimate", this.localEstimate);
      this.close();
    } catch (e) {
      handleError(e);
    } finally {
      this.requestsLoading = false;
    }

    return {
      repairEstimate: this.localEstimate
    };
  }
}
